import { render, staticRenderFns } from "./LoginWidget.vue?vue&type=template&id=b2efa9c2&"
import script from "./LoginWidget.vue?vue&type=script&lang=js&"
export * from "./LoginWidget.vue?vue&type=script&lang=js&"
import style0 from "./LoginWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports